import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Dictionary',
  basePath: '/dict',
  columns: [
    { key: 'dict_name', label: 'Subject', sortable: true },
    { key: 'updated', label: 'Updated', sortable: true },
  ],
  fields: [
    { key: 'dict_name', label: 'Subject', type: 'text', required: true },
    { key: 'dict_text', label: 'Explanation', type: 'rich-text' },
  ],
  defaultSort: { field: 'dict_name', dir: 'asc' },
});
